export default __webpack_public_path__ + "static/media/linux.d0b705f8.svg";